import React, { useEffect } from "react";

const AlertDialog = ({ isVisible, onClose, message }) => {
    useEffect(() => {
        if (isVisible) {
            const timer = setTimeout(() => {
                onClose();
            }, 3000);
            return () => clearTimeout(timer);
        }
    }, [isVisible, onClose]);

    if (!isVisible) return null;

    return (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
            <div className="w-[90%] max-w-[349px] p-[22px] bg-white rounded-md shadow-md border border-gray-200 flex flex-col items-center gap-3">
                <div className="flex items-center gap-3">
                    <div className="w-15 h-15 pt-[6.50px] pb-[5.50px] justify-center items-center flex overflow-hidden">
                        <img
                            className="w-10 h-auto"
                            src="/images/icon/alert.png"
                            alt="Ícone de Sucesso"
                        />
                    </div>
                    <div className="text-stone-800 text-lg font-semibold">
                        {message}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AlertDialog;
